var Vendd = (function (Vendd) {
	'use strict';

	Vendd.ProjectAgora = (function (ProjectAgora) {

		ProjectAgora.Messages = (function (Messages) {

			Messages.GetBanner = function (widgetId, searchTerm, categoryPathComponents) {
				searchTerm = searchTerm || '';
				categoryPathComponents = categoryPathComponents || '';

				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProjectAgora.Messages.GetBanner', {
					widgetId: widgetId,
					filters: {
						SearchTerm: searchTerm,
						CategoryPathComponents: (categoryPathComponents.length) ? categoryPathComponents.split(',') : []
					}
				});
			};
			Messages.GetBanner.className = 'Vendd.ProjectAgora.Messages.GetBanner';

			Messages.GetBannerSuccess = function (widgetId, model) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProjectAgora.Messages.GetBannerSuccess', {
					widgetId: widgetId,
					model: model
				});
			};
			Messages.GetBannerSuccess.className = 'Vendd.ProjectAgora.Messages.GetBannerSuccess';

			Messages.GetBannerFailure = function (widgetId, error) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProjectAgora.Messages.GetBannerFailure', {
					widgetId: widgetId,
					error: error
				});
			};
			Messages.GetBannerFailure.className = 'Vendd.ProjectAgora.Messages.GetBannerFailure';

			Messages.TrackBannerImpression = function (bannerId) {
				Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProjectAgora.Messages.TrackBannerImpression', {
					bannerId: bannerId
				});
			};
			Messages.TrackBannerImpression.className = 'Vendd.ProjectAgora.Messages.TrackBannerImpression';

			return Messages;

		})(ProjectAgora.Messages || {});

		return ProjectAgora;

	})(Vendd.ProjectAgora || {});

	return Vendd;

})(Vendd || {});